import { render, staticRenderFns } from "./DarkCompany.vue?vue&type=template&id=d2866fb4&"
import script from "./DarkCompany.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkCompany.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports